import { RefObject, useEffect, useState } from "react";

export type ResponsivePlotTier = "phone" | "narrow" | "wide";

export function responsivePlotTier(width: number): ResponsivePlotTier {
  if (width > 0 && width < 480) return "phone";
  if (width > 0 && width < 720) return "narrow";
  return "wide";
}

export function useElementSize<T extends HTMLElement>(ref: RefObject<T>) {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const updateSize = () => {
      const rect = element.getBoundingClientRect();
      setSize({
        width: Math.round(rect.width),
        height: Math.round(rect.height)
      });
    };

    updateSize();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", updateSize, { passive: true });
      return () => window.removeEventListener("resize", updateSize);
    }

    const observer = new ResizeObserver(updateSize);
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref]);

  return size;
}
